if (!customElements.get('back-to-top')) {
  customElements.define(
    'back-to-top',
    class BackToTop extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.onClick = this.onClick.bind(this);
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      onClick() {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        document.getElementById('MainContent')?.focus({ preventScroll: true });
      }
    }
  );
}
